const { createSelector } = require("reselect");

const selectCoupon = (state) => state["marketplace.marketCoupon"].coupon;

const coupon = () => createSelector([selectCoupon], (show) => show.data);

const couponError = () => createSelector([selectCoupon], (show) => show.error);

const couponLoading = () =>
  createSelector([selectCoupon], (show) => show.loading);

const selectCouponList = (state) =>
  state["marketplace.marketCoupon"].couponList;

const couponList = () =>
  createSelector([selectCouponList], (show) => show.data);

const couponListError = () =>
  createSelector([selectCouponList], (show) => show.error);

const couponListLoading = () =>
  createSelector([selectCouponList], (show) => show.loading);

const selectCouponSuggestion = (state) =>
  state["marketplace.marketCoupon"].couponSuggestion;

const couponSuggestion = () =>
  createSelector([selectCouponSuggestion], (show) => show.data);

const couponSuggestionError = () =>
  createSelector([selectCouponSuggestion], (show) => show.error);

const couponSuggestionLoading = () =>
  createSelector([selectCouponSuggestion], (show) => show.loading);

const selectApplyCoupon = (state) =>
  state["marketplace.marketCoupon"].appliedCoupon;

const applyForCoupon = () =>
  createSelector([selectApplyCoupon], (show) => show.data);

const applyForCouponError = () =>
  createSelector([selectApplyCoupon], (show) => show.error);

const applyForCouponLoading = () =>
  createSelector([selectApplyCoupon], (show) => show.loading);

module.exports = {
  coupon,
  couponLoading,
  couponError,

  couponList,
  couponListLoading,
  couponListError,

  couponSuggestion,
  couponSuggestionLoading,
  couponSuggestionError,

  applyForCoupon,
  applyForCouponLoading,
  applyForCouponError,
};
